<div class="container-scroller content-wrapper">
  <div class="d-flex col-10 col-lg-11 col-md-10 col-sm-9 mx-auto central-main mt-2">
    <img class="header-logo cursor-pointer" routerLink="/home" src="assets/svg/logo.svg" alt="header logo">
  </div>
  <div class="container-fluid page-body-wrapper full-page-wrapper change-password-page">
    <div class="content-wrapper d-flex align-items-center auth px-0">
      <div class="row w-100 mx-0">
        <div class="mx-auto">
          <div class="auth-form-light text-left py-5 px-4 px-sm-5">
            <h4 class="password-reset-title">{{ 'create_password_page.create_password' | translate }}</h4>
            <form [formGroup]="changePasswordForm" (ngSubmit)="sendResetLink()"
                  (keydown.enter)="$event.preventDefault(); forgotButton.focus(); forgotButton.click()" method="post"
                  class="pt-3">
              <div class="form-group">
                <div class="password-input-container">
                  <input formControlName="password" (input)="onInputSpaceChange($event, SharedConstants.PASSWORD)" [type]="showPassword ? 'text' : 'password'" #passwordInput
                         [placeholder]="'create_password_page.placeholder_password' | translate" class="form-control form-control-lg password-reduced-placeholder-width"
                         [ngClass]="{'has-error': changePasswordFormControl['password'].invalid && changePasswordFormControl['password'].touched}"/>
                  <span class="eye-icon">
                    <i class="bi" [ngClass]="{'bi-eye': showPassword, 'bi-eye-slash': !showPassword}"
                       (click)="togglePasswordVisibility('password')"></i>
                  </span>
                </div>
                @if (changePasswordFormControl['password'].invalid && changePasswordFormControl['password'].touched) {
                  <div class="validation">
                    @if (changePasswordFormControl['password'].errors?.['required']) {
                      <small class="error-message">{{ 'create_password_page.password_error' | translate }}</small>
                    }
                    @if (changePasswordFormControl['password'].errors?.['pattern']) {
                      <small>
                        @for (criteria of criteriaList; track criteria) {
                          <div class="box">
                            @if (isPasswordValid(criteria)) {
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_3025_42178" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                      y="0" width="24" height="24">
                                  <rect width="24" height="24" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#mask0_3025_42178)">
                                  <path
                                    d="M9.54986 14.6696L17.7705 6.4489C18.0364 6.18295 18.3517 6.04998 18.7162 6.04998C19.0807 6.04998 19.3959 6.18295 19.6618 6.4489C19.9278 6.71485 20.0607 7.03008 20.0607 7.39458C20.0607 7.75906 19.9278 8.07428 19.6618 8.34023L10.4901 17.512C10.2241 17.7779 9.91073 17.9109 9.54986 17.9109C9.18899 17.9109 8.87558 17.7779 8.60963 17.512L4.33788 13.2402C4.07195 12.9743 3.94079 12.6591 3.94441 12.2946C3.94803 11.9301 4.08281 11.6149 4.34876 11.3489C4.61471 11.083 4.92993 10.95 5.29443 10.95C5.65892 10.95 5.97413 11.083 6.24008 11.3489L9.54986 14.6696Z"
                                    fill="#1ED030"/>
                                </g>
                              </svg>
                            } @else {
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_3025_42184" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                      y="0" width="24" height="24">
                                  <rect width="24" height="24" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#mask0_3025_42184)">
                                  <path
                                    d="M11.9998 13.1665L6.86651 18.2998C6.70534 18.4609 6.51084 18.5415 6.28301 18.5415C6.05534 18.5415 5.86092 18.4609 5.69976 18.2998C5.53859 18.1386 5.45801 17.9442 5.45801 17.7165C5.45801 17.4887 5.53859 17.2942 5.69976 17.133L10.833 11.9998L5.69976 6.86651C5.53859 6.70534 5.45801 6.51084 5.45801 6.28301C5.45801 6.05534 5.53859 5.86092 5.69976 5.69976C5.86092 5.53859 6.05534 5.45801 6.28301 5.45801C6.51084 5.45801 6.70534 5.53859 6.86651 5.69976L11.9998 10.833L17.133 5.69976C17.2942 5.53859 17.4887 5.45801 17.7165 5.45801C17.9442 5.45801 18.1386 5.53859 18.2998 5.69976C18.4609 5.86092 18.5415 6.05534 18.5415 6.28301C18.5415 6.51084 18.4609 6.70534 18.2998 6.86651L13.1665 11.9998L18.2998 17.133C18.4609 17.2942 18.5415 17.4887 18.5415 17.7165C18.5415 17.9442 18.4609 18.1386 18.2998 18.2998C18.1386 18.4609 17.9442 18.5415 17.7165 18.5415C17.4887 18.5415 17.2942 18.4609 17.133 18.2998L11.9998 13.1665Z"
                                    fill="#D22627"/>
                                </g>
                              </svg>
                            }
                            <span class="text">{{ getCriteriaText(criteria) }}</span>
                          </div>
                        }
                      </small>
                    }
                  </div>
                }
              </div>
              <div class="form-group">
                <div class="password-input-container">
                  <input formControlName="confirmPassword" (input)="onInputSpaceChange($event, SharedConstants.CONFIRM_PASSWORD)" [type]="showConfirmPassword ? 'text' : 'password'"
                         #confirmPasswordInput    [placeholder]="'create_password_page.confirm_password_placeholder' | translate"
                         class="form-control form-control-lg confirm-password-reduced-placeholder-width"
                         [ngClass]="{'has-error': changePasswordFormControl['confirmPassword'].invalid && changePasswordFormControl['confirmPassword'].touched || (changePasswordFormControl['confirmPassword'].value !== '' && passwordMatchValidator(changePasswordForm))}"/>
                  <span class="eye-icon">
                    <i class="bi" [ngClass]="{'bi-eye': showConfirmPassword, 'bi-eye-slash': !showConfirmPassword}"
                       (click)="togglePasswordVisibility('confirmPassword')"></i>
                  </span>
                </div>
                @if (passwordMatchValidator(changePasswordForm) && changePasswordFormControl['confirmPassword'].value !== '') {
                  <div class="validation">
                    <small>{{ 'create_password_page.confirm_password_error' | translate }}</small>
                  </div>
                }
              </div>
              <div class="mt-3">
                <button class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" type="submit"
                        [disabled]="changePasswordForm.invalid || passwordMatchValidator(changePasswordForm)"
                        #forgotButton>{{'create_password_page.confirm_button' | translate}}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
